import moment from "moment-timezone";
import React, { useState } from "react";

import { Button2 } from "@/ui2/atoms/Button";
import DownloadIcon from "@/assets/images/icons2/icon--download.svg?component";
import EyeIcon from "@/assets/images/icons2/icon--eye.svg?component";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { getReportPresignedUrl, viewReport } from "@/utils/fileUtil";
import ImageFullPreview from "@/components/Common/ImageFullPreview";
import { SINGLE_REPORT_TYPES } from "@/core/constants/reports";

import { getReportByType } from "./helpers";
import { MultipleReports } from "./components/MultipleReports";
import { SingleReport } from "./components/SingleReport";

export function MemberProfileReports({ data }) {
  const [isPreviewOpen, setIsPreviewOpen] = useState(null);
  const reports = data || [];

  const renderMetaAndDownloadButton = (report, isAccessible = true) => {
    const timestamp = Object.hasOwn(report, "timestamp") && report.timestamp;

    return (
      <div className="tw:flex tw:justify-between">
        <p className="tw:flex tw:flex-col">
          <b className="tw:text-sm">Created on:</b>
          <span className="body-sm">
            {moment.utc(timestamp).tz("America/New_York").format("MM/DD/YYYY")}
          </span>
        </p>

        {isAccessible && (
          <Button2
            className="tw:p-2"
            onPress={async () => {
              await viewReport(report);
            }}
            rawChildren
            variant="text"
          >
            <DownloadIcon />
          </Button2>
        )}
      </div>
    );
  };

  const renderViewButton = (report) => {
    return (
      <Button2
        className="tw:p-2 tw:text-fill-teal-primary"
        onPress={async () => {
          let file_url = await getReportPresignedUrl(report);

          setIsPreviewOpen(file_url);
        }}
        rawChildren
        variant="text"
        {...getAutomationDataAttr("ViewReport")}
      >
        <EyeIcon />
      </Button2>
    );
  };

  return (
    <>
      <ul className="tw:mt-6 tw:flex tw:list-none tw:flex-col tw:gap-4">
        <MultipleReports
          renderMetaAndDownloadButton={renderMetaAndDownloadButton}
          renderViewButton={renderViewButton}
          reports={reports}
          type="A5-R"
        />

        <MultipleReports
          renderMetaAndDownloadButton={renderMetaAndDownloadButton}
          renderViewButton={renderViewButton}
          reports={reports}
          type="A5"
        />

        {/* // TODO: SNS-E is a repeating report!*/}
        {SINGLE_REPORT_TYPES.map((type) => {
          const report = getReportByType({ reports, type });
          const isPresent = report !== null;

          return (
            <SingleReport
              customButton={isPresent ? renderViewButton(report) : null}
              id={type}
              isEnabled={isPresent}
              key={type}
              metaData={isPresent ? renderMetaAndDownloadButton(report) : null}
              title={`${type} Report`}
            />
          );
        })}
      </ul>

      {isPreviewOpen && (
        <ImageFullPreview
          close={() => setIsPreviewOpen(false)}
          fileType="pdf"
          url={isPreviewOpen}
          wideView={true}
        />
      )}
    </>
  );
}
